import {Component, OnInit} from '@angular/core';
import {NewBlank} from '../../../../models/new-blank.model';
import {PrefixService} from '../../../../services/frefix.service';
import {ViewDocxService} from '../../../../services/view-docx.service';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import {StandardTypesService} from '../../../../services/standard-types.service';
import {AdminService} from '../../../../services/admin.service';
import {ApiConnectService} from '../../../../services/api-connect.service';
import {UserService} from '../../../../services/user.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmationPopupComponent} from '../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-steps-blanks',
  templateUrl: './steps-blanks.component.html',
  styleUrls: ['./steps-blanks.component.css']
})

export class StepsBlanksComponent implements OnInit {

  newBlanks: NewBlank[] = [];
  isLoaded = true;
  thisStandard: any;

  constructor(public prefixService: PrefixService,
              public viewDocxService: ViewDocxService,
              public stepsControllerService: StepsControllerService,
              public standardTypesService: StandardTypesService,
              private adminService: AdminService,
              private apiConnectService: ApiConnectService,
              private userService: UserService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    // Get standard
    if (this.stepsControllerService.getCurrentStandard()) {
      this.thisStandard = this.stepsControllerService.getCurrentStandard();

    } else {
      this.thisStandard = null;
    }
  }

  addNewBlank() {
    this.newBlanks.push(new NewBlank(null, null, null));
  }

  validationBlank(blank) {
    return blank.number !== null && blank.number.trim() !== '' &&
      blank.name !== null && blank.name.trim() !== '' &&
      blank.formData;
  }

  blanksChange(event, index: number) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.newBlanks[index].formData = formData;
    } else {
      this.newBlanks[index].formData = null;
    }
  }

  deleteBlank(key) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTB';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        if (key > -1) {
          this.newBlanks.splice(key, 1);
        }
      }
    });
  }

  downloadFile(id) {
    this.isLoaded = false;
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
        this.isLoaded = true;
      }
    );
  }


  deleteBlankFile(blank) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTBF';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.adminService.deleteBlankFromStandard(blank, this.stepsControllerService.currentStandard).subscribe(
          (response: any) => {
            if (response.status === 200) {
              this.stepsControllerService.showByFilesAndBlanks = true;
              const index = this.thisStandard.blanks.indexOf(blank);
              this.thisStandard.blanks.splice(index, 1);
            }
          },
          () => {
          }
        );
      }
    });
  }


  saveBlank(index) {
    if (this.validationBlank(this.newBlanks[index])) {
      this.stepsControllerService.showByFilesAndBlanks = false;
      this.adminService.uploadBlank(this.thisStandard, [this.newBlanks[index]]).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.stepsControllerService.showByFilesAndBlanks = true;
            this.thisStandard.blanks.push(response.body[0]);
            this.newBlanks.splice(index, 1);
          }
        }
      );
    }
  }


}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/steps-blanks/steps-blanks.component.ts